import AllariaMasHeader from "./AllariaMasHeader";
import AllariaMasBody from "./AllariaMasBody";
import { ModalFooter } from "@nextui-org/react";
import Button from "../../../Button/Button";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  closeModal,
  updateAction,
} from "../../../../store/slices/unifiedBalanceSlice";
import { openModal as openDepositModal } from "../../../../store/slices/depositSlice";
import useScreenSize from "../../../../hooks/useScreenSize";
import styles from "./AllariaMasBody.module.scss";

const AllariaMasModal = () => {
  const { modalFooterMobile, unificarBtn, cerrarBtn } = styles;
  const dispatch = useAppDispatch();
  const { isMobile } = useScreenSize();
  const { returnToDepositModal } = useAppSelector(
    (state) => state.unifiedBalance
  );

  return (
    <>
      <AllariaMasHeader />
      <AllariaMasBody />
      <ModalFooter
        className={!isMobile ? "flex justify-center items-center" : ""}
      >
        <div className={isMobile ? modalFooterMobile : "flex gap-4"}>
          <Button
            isAllariaMas
            variant="secondary"
            text={!!returnToDepositModal ? "Volver" : "Cerrar"}
            onPress={() => {
              dispatch(closeModal());
              !!returnToDepositModal && dispatch(openDepositModal());
            }}
            className={`${cerrarBtn} ${isMobile ? "w-full mb-2.5" : ""}`}
          />
          <Button
            isAllariaMas
            variant="primary"
            text="Unificar saldos"
            onPress={() => dispatch(updateAction("ACCOUNTS_SELECTOR"))}
            className={`${unificarBtn} ${isMobile ? "w-full" : ""}`}
          />
        </div>
      </ModalFooter>
    </>
  );
};

export default AllariaMasModal;
